import { render, staticRenderFns } from "./JobsMonitorJobCard.vue?vue&type=template&id=9338107c&scoped=true&"
import script from "./JobsMonitorJobCard.vue?vue&type=script&lang=js&"
export * from "./JobsMonitorJobCard.vue?vue&type=script&lang=js&"
import style0 from "./JobsMonitorJobCard.vue?vue&type=style&index=0&id=9338107c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9338107c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VDivider,VIcon})
